export default __webpack_public_path__ + "static/media/DNo.35-4.1926a729.jpg";